import { ActionableTrains } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains";
import { EventHeader } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/EventHeader";
import { InfrastructureEventSummaryPanels } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/InfrastructureEventSummaryPanels";
import { SectionBoxWithStickyHeader } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/SectionBoxWithStickyHeader";
import DecisionSupportContext from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/DecisionSupportContext";
import { AltTransStretchCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { useDecisionSupportData } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useDecisionSupportData";
import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { Box, Skeleton, tokens } from "shared/components/Spor";
import styled from "styled-components";

const DecisionSupportWrapper = styled(Box)`
  container-type: inline-size;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};

  padding: ${tokens.default.size.spacing[4]};

  @container (width < 1400px) {
    .DontShowIfSmallWidth {
      display: none;
    }
  }
`;

const ContentLayoutWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${tokens.default.size.spacing[2]};
  width: 100%;
`;

const ScrollableDetailsWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
`;

const DecisionSupport = () => {
  const { uuid } = useParams();

  const {
    contextValue,
    infrastructureEvent,
    infrastructureInformationStatus,
    incidentPlanLoadingState,
    relatedInfrastructureIncidentPlan,
    setShowAllStretches,
    showAllStretches,
  } = useDecisionSupportData(uuid);

  const [selectedStretch, setSelectedStretch] =
    useState<AltTransStretchCoverage | null>(null);

  if (infrastructureInformationStatus === "pending") {
    return (
      <>
        <TabsCenter />
        <DecisionSupportWrapper>
          <Skeleton height="200px" />
        </DecisionSupportWrapper>
      </>
    );
  }

  if (infrastructureInformationStatus === "error" || !infrastructureEvent) {
    return (
      <>
        <TabsCenter />
        <DecisionSupportWrapper>
          <FailureMessage />
        </DecisionSupportWrapper>
      </>
    );
  }

  return (
    <>
      <TabsCenter />

      <DecisionSupportContext.Provider value={contextValue}>
        <ScrollableDetailsWrapper>
          <SectionBoxWithStickyHeader
            headerContent={
              <EventHeader
                event={infrastructureEvent}
                incidentPlanStatus={
                  relatedInfrastructureIncidentPlan?.event?.status
                }
                incidentPlanLoadingState={incidentPlanLoadingState}
              />
            }
          >
            <ContentLayoutWrapper>
              <InfrastructureEventSummaryPanels
                event={infrastructureEvent}
                selectedStretch={selectedStretch}
                setSelectedStretch={setSelectedStretch}
                showAllStretches={showAllStretches}
                setShowAllStretches={setShowAllStretches}
              />
              <ActionableTrains event={infrastructureEvent} />
            </ContentLayoutWrapper>
          </SectionBoxWithStickyHeader>
        </ScrollableDetailsWrapper>
      </DecisionSupportContext.Provider>
    </>
  );
};

export default DecisionSupport;
